<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师上课记录</Breadcrumb-item>
        <Breadcrumb-item>学生早退详情</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="16" :md="10" >
          </Col>
          <Col :xs="12" :sm="8" :md="5">
          <Form-item label="课程类型" :label-width="75">
            <Select v-model.number="queryParam.lsnType" placeholder="全部"
                    @on-change="search" clearable>
              <Option v-for="item in $constant.bookLessonOpenedLsnType"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="4">
          <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                  @click="search" >搜索
          </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bc/listStudentEarlyDetail"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
    <EarlyLessonMemeberTimeModal :openedId="openId" v-model="showClassMemberTimeModal"></EarlyLessonMemeberTimeModal>
  </div>
</template>
<script>
  import EarlyLessonMemeberTimeModal from './EarlyLessonMemberTimeModal.vue'
  export default {
    components: {
      EarlyLessonMemeberTimeModal,
    },
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        exportLoading: false,
        showClassMemberTimeModal: false,
        openId: null,
        reload: 0,
        queryParam: {
          tchId: '',
          uid: '',
          userNickname: '',
          adminNickname: '',
          lessonStartTime: '',
          lessonEndTime: '',
          lsnType: '',
        },
        title: [
          {
            title: '学生姓名/ID',
            render: (h, params) => {
              let row = params.row
              return h('span', row.nickName + '-' + row.uid)
            }
          },
          {
            title: '课程名称',
            key: 'lessonName',
          },
          {
            title: '课程类型',
            render: (h, params) => {
              let lsnType = params.row.lsnType
              let typeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType)
              return h('span', typeEnum && typeEnum.text)
            }
          },
          {
            title: '课程开始时间时间',
            key: 'lessonStartTime'
          },
          {
            title: '课程时长(分钟)',
            key: 'lessonLength',
            render: (h, params) => {
              let row = params.row
              return h('span', (row.lessonLength / 60))
            }
          },
          {
            title: '进出教室记录',
            align: 'center',
            render: (h, params) => {
              return h('a', {on: {click: () => {
                this.openId = params.row.openId
                this.showClassMemberTimeModal = true
              }}}, '查看')
            }
          },
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
      this.queryParam.tchId = localStorage.tchId
      this.queryParam.lessonStartTime = localStorage.startTime
      this.queryParam.lessonEndTime = localStorage.endTime
    },
    methods: {
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      },
    }
  }

</script>



// WEBPACK FOOTER //
// StudentEarlyDetail.vue?8c9603ec